import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams, useLocation, Outlet } from 'react-router-dom'

import Dashboard from '../Dashboard'
import ModalContainer from '../ModalContainer/ModelContainer'
import RequestMaintenanceForm from '../Maintenance/RequestMaintenanceForm/RequestMaintenanceForm'

import InternalInspectionsNavbar from './InternalInspectionsNavbar'
import ScheduleInspectionModal from './ScheduleInspectionModal/ScheduleInspectionModal'

const InternalInspections = () => {
  const { t } = useTranslation(['internal-inspections'])
  const [scheduleInspectionVisible, setScheduleInspectionVisible] = useState(false)
  const [workOrderModalVisible, setWorkOrderModalVisible] = useState(false)
  const [showAnalytics, setShowAnalytics] = useState(true)

  const { inspectionId } = useParams()
  const location = useLocation()

  return (
    <Dashboard.Container className="ctp-internal-inspections">
      <InternalInspectionsNavbar
        location={location}
        onScheduleInspection={() => setScheduleInspectionVisible(true)}
        onCreateWorkOrder={() => setWorkOrderModalVisible(true)}
        onToggleAnalytics={() => setShowAnalytics((prev) => !prev)}
        showAnalytics={showAnalytics}
      />

      {/* Inject context or prop state here if needed */}
      <Outlet context={{ showAnalytics }} />

      {scheduleInspectionVisible && (
        <ScheduleInspectionModal onClose={() => setScheduleInspectionVisible(false)} />
      )}

      {workOrderModalVisible && inspectionId && (
        <ModalContainer
          headerTitle={t('internal-inspections:createMaintenanceRequest')}
          onClose={() => setWorkOrderModalVisible(false)}
        >
          <RequestMaintenanceForm
            toggleModal={() => setWorkOrderModalVisible(false)}
            inspectionId={parseInt(inspectionId)}
          />
        </ModalContainer>
      )}
    </Dashboard.Container>
  )
}

export default InternalInspections
